import { useDispatchedLiveDrivers } from './useDispatchedLiveDrivers';
import { useRoutesWithTasks } from './useRoutesWithTasks';

export function useDispatchedDriversWithTasks() {
    const dispatchedLiveDrivers = useDispatchedLiveDrivers();
    return useRoutesWithTasks(dispatchedLiveDrivers);
}
